import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import { about } from './locales/pt-BR/about'
import { common } from './locales/pt-BR/common'
import { home } from './locales/pt-BR/home'
import { player } from './locales/pt-BR/player'
import { sections } from './locales/pt-BR/sections'
import { streamers } from './locales/pt-BR/streamers'

export const defaultNS = 'common'

export const resources = {
  'pt-BR': {
    common,
    home,
    player,
    sections,
    about,
    streamers,
  },
} as const

void i18n.use(initReactI18next).init({
  lng: 'pt-BR',
  fallbackLng: 'pt-BR',
  defaultNS,
  resources,
  interpolation: {
    // React already escapes values, so i18next must not double-escape.
    escapeValue: false,
  },
})

export default i18n
